var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FieldBox',{staticClass:"loss-price",attrs:{"title":_vm.title}},[_c('PlusMinusInput',{attrs:{"precision":_vm.precision,"step":_vm.minTick,"min":0,"max":999999999,"match-tick":true,"match-precision":true},model:{value:(_vm.stopLossPrice),callback:function ($$v) {_vm.stopLossPrice=$$v},expression:"stopLossPrice"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }